import device from 'vue-device-detector'
import Vue from 'vue'

Vue.use(device)
